import Dialog from "@mui/material/Dialog";
import Cookies from "js-cookie";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import ACTIONS, {
  fetchAspPotentialProviders,
  fetchAspQuickResultSummary,
  fetchAspTopProvidersByMatchScore,
  fetchCherryPotentialProviders,
} from "../../redux/action.js";
import axios from "../../shared/axios/axiosProxy.js";
import KnetPlusForm from "../../shared/components/knetPlusForm/knetPlus.jsx";
import VacationNotice from "../../shared/components/vacationNotice/VacationNotice.jsx";
import i18n from "../../utils/i18n.js";
import { pushFlowContextToDataLayer } from "../utils/dataLayerFlowContext";
import { ensureSearchExists } from "../utils/ensureSearchExists";
import {
  mergeUtmIntoPayload,
  prepareAspPayload,
  resolveUtmParams,
} from "../utils/utmBootstrap";
import Monitors from "./components/monitors/monitors.jsx";
import SearchFlowFooterShell from "./components/searchFlowFooter/SearchFlowFooterShell.jsx";
import SearchFlowFooterProviderCount from "./components/searchFlowFooter/SearchFlowFooterProviderCount.jsx";
import SearchFlowHeader from "./components/searchFlowHeader/SearchFlowHeader.jsx";
import { checkStateChange } from "./data/searchFlowText.js";
import {
  Accounts,
  AspProviders,
  Banks,
  CompanyType,
  FakeCherryProviders,
  FirstStep,
  FlowSwitch,
  ForeignTrade,
  Income,
  Industry,
  InvoicesIn,
  InvoicesOut,
  Languages,
  Needs,
  Preferences,
  Software,
  Taxform,
  Vat,
} from "./newsteps/index.js";
import IndustrySpecific from "./newsteps/industrySpecific.jsx";
import IndustrySpecificGeneral from "./newsteps/industrySpecificGeneral.jsx";
import classes from "./searchFlow.module.scss";
import CommonCegjelzoAuto from "./steps/common/CommonCegjelzoAuto.jsx";
import CommonCompanyType from "./steps/common/CommonCompanyType.jsx";
import CommonFillingMethod from "./steps/common/CommonFillingMethod.jsx";
import CommonKftCegjelzoInterstitial from "./steps/common/CommonKftCegjelzoInterstitial.jsx";
import CommonKftInterstitial from "./steps/common/CommonKftInterstitial.jsx";
import GeneralError from "./steps/common/GeneralError.jsx";
import CommonMoreBranch from "./steps/common/CommonMoreBranch.jsx";
import CommonRouting from "./steps/common/CommonRouting.jsx";
import CommonValueProp from "./steps/common/CommonValueProp.jsx";
import NewMultiCompanyInterstitial from "./steps/common/NewMultiCompanyInterstitial.jsx";
import CompanyCegjelzoTaxForm from "./steps/company/CompanyCegjelzoTaxForm.jsx";
import CompanyContactPage from "./steps/company/CompanyContactPage.jsx";
import CompanyEmployeeNo from "./steps/company/CompanyEmployeeNo.jsx";
import CompanyForeignTrade, {
  companyIndustryHasForeignTradeStep,
} from "./steps/company/CompanyForeignTrade.jsx";
import CompanyIndustryActivity, {
  companyIndustryHasActivityContent,
} from "./steps/company/CompanyIndustryActivity.jsx";
import CompanyIndustrySelect from "./steps/company/CompanyIndustrySelect.jsx";
import CompanyQuickResult from "./steps/company/CompanyQuickResult.jsx";
import CompanyRevenue from "./steps/company/CompanyRevenue.jsx";
import CompanySuccessScreen from "./steps/company/CompanySuccessScreen.jsx";
import CompanyTaxForm from "./steps/company/CompanyTaxForm.jsx";
import CompanyVatStatus from "./steps/company/CompanyVatStatus.jsx";
import EvCegjelzoTaxForm from "./steps/ev/EvCegjelzoTaxForm.jsx";
import EvContactPage from "./steps/ev/EvContactPage.jsx";
import EvForeignTradeStep, {
  evIndustryHasForeignTradeStep,
} from "./steps/ev/EvForeignTrade.jsx";
import EvIndustryActivity, {
  evIndustryHasActivityContent,
} from "./steps/ev/EvIndustryActivity.jsx";
import EvIndustrySelect from "./steps/ev/EvIndustrySelect.jsx";
import EvQuickResult from "./steps/ev/EvQuickResult.jsx";
import EvRevenue from "./steps/ev/EvRevenue.jsx";
import EvSuccessScreen from "./steps/ev/EvSuccessScreen.jsx";
import EvTaxForm, { isEntrepreneurTaxCompanyType } from "./steps/ev/EvTaxForm.jsx";
import EvVatStatus from "./steps/ev/EvVatStatus.jsx";
import NewCompanyType from "./steps/other/NewCompanyType.jsx";
import {
  CEGJELZO_REGISTRY_TYPES,
  isCegjelzoRegistryTypeAutoFillSupported,
  isEvCompanyType,
  normalizeCegjelzoRegistryType,
} from "./utils/cegjelzo/mapCegjelzoCompanyData.js";
import { persistCegjelzoCompany } from "./utils/cegjelzo/persistCegjelzoCompany.js";
import { persistIndustryWithFinancialDefaults } from "./utils/persistIndustryWithFinancialDefaults.js";
import { getStepFooterNav } from "./utils/searchFlowFooterNav.js";
import { prefetchAspQuickResult } from "./utils/prefetchAspQuickResult.js";
import { isAspManualPostQuickResultFooterCountStep } from "./utils/aspManualFooterProviderCount.js";
import {
  computeAspProgressValue,
  getAspSearchFlowProgress,
} from "./utils/searchFlowProgress.js";
import { createSearchFlowAnalytics } from "./analytics/searchFlowAnalytics.js";
import {
  normalizeEntryFlowSlug,
  resolveExitFlowSlug,
} from "./analytics/searchFlowStepRegistry.js";

const USE_WIREFRAME_ROUTE = true;

const ENABLE_SEARCH_FLOW_MONITORS = false;

const SHOW_CONTINUE_LATER_BUTTON = false;

const TYPEFORM_MULTIPLE_BUSINESSES_URL =
  "https://t40tz85n2uw.typeform.com/tobbvallalkozas?typeform-source=dashboard-hu.bookkeepie.com";

const WIREFRAME_STEPS = [
  { component: CommonValueProp },
  {
    component: CommonRouting,
    extraProps: (self) => ({
      routingSelection: self.state.routingSelection,
      onRoutingChange: self.setRoutingSelection,
      onRoutingNext: self.handleRoutingNext,
      onRoutingBack: self.handleRoutingBack,
    }),
  },
  {
    component: NewCompanyType,
    extraProps: (self) => ({
      regCompanyTypeSelection: self.state.regCompanyTypeSelection,
      setRegCompanyTypeSelection: self.setRegCompanyTypeSelection,
      onNewCompanyTypeBack: self.handleNewCompanyTypeBack,
      onNewCompanyTypeNext: self.handleNewCompanyTypeNext,
    }),
  },
  {
    component: CommonMoreBranch,
    extraProps: (self) => ({
      moreBranchSelection: self.state.moreBranchSelection,
      onMoreBranchChange: self.setMoreBranchSelection,
      onMoreBranchNext: self.handleMoreBranchNext,
      onMoreBranchBack: self.handleMoreBranchBack,
    }),
  },
  {
    component: NewMultiCompanyInterstitial,
    extraProps: (self) => ({
      selection: self.state.multiCompanyInterstitialSelection,
      onSelectionChange: self.setMultiCompanyInterstitialSelection,
      bookingDialogOpen: self.state.multiCompanyBookingDialogOpen,
      onBookingDialogOpenChange: self.setMultiCompanyBookingDialogOpen,
    }),
  },
  {
    component: CommonFillingMethod,
    extraProps: (self) => ({
      fillingMethodSelection: self.state.fillingMethodSelection,
      onFillingMethodChange: self.setFillingMethodSelection,
      onFillingMethodBack: self.handleFillingMethodBack,
      onFillingMethodNext: self.handleFillingMethodNext,
    }),
  },
  {
    component: CommonCegjelzoAuto,
    extraProps: (self) => ({
      selectedCompany: self.props.company_store?.cegjelzoData || null,
      cegjelzoPersistError: self.state.cegjelzoPersistError,
      onClearCegjelzoPersistError: self.clearCegjelzoPersistError,
      onSetCegjelzoPersistError: self.setCegjelzoPersistError,
      saveCegjelzoData: self.saveCegjelzoData,
      clearCegjelzoData: self.clearCegjelzoData,
      addCompanyInfo: self.props.addCompanyInfo,
      setIndustrySelection: self.setIndustrySelection,
      setCompanyTypeFlowSelection: self.setCompanyTypeFlowSelection,
    }),
  },
  {
    component: EvCegjelzoTaxForm,
    extraProps: (self) => ({
      onEvCegjelzoTaxFormNext: self.handleEvCegjelzoTaxFormNext,
      onEvCegjelzoTaxFormBack: self.handleEvCegjelzoTaxFormBack,
      onInteractedChange: self.handleEvTaxFormInteractedChange,
      initialInteracted: self.state.evTaxFormInteracted,
    }),
  },
  {
    component: CommonKftCegjelzoInterstitial,
    extraProps: (self) => ({
      selection: self.state.kftCegjelzoInterstitialSelection,
      onSelectionChange: self.setKftCegjelzoInterstitialSelection,
      bookingDialogOpen: self.state.kftCegjelzoBookingDialogOpen,
      onBookingDialogOpenChange: self.setKftCegjelzoBookingDialogOpen,
    }),
  },
  {
    component: CompanyCegjelzoTaxForm,
    extraProps: (self) => ({
      onInteractedChange: self.handleCompanyTaxFormInteractedChange,
      initialInteracted: self.state.companyTaxFormInteracted,
    }),
  },
  {
    component: CommonCompanyType,
    extraProps: (self) => ({
      companyTypeFlowSelection: self.state.companyTypeFlowSelection,
      onCompanyTypeChange: self.setCompanyTypeFlowSelection,
      onCompanyTypeSoleProprietorshipNext:
        self.handleCompanyTypeSoleProprietorshipNext,
      onCompanyTypeCompanyNext: self.handleCompanyTypeCompanyNext,
      onCompanyTypeRegIndustrySelectNext:
        self.handleCompanyTypeRegIndustrySelectNext,
      handleBack: self.handleCompanyTypeBack,
    }),
  },
  {
    component: CommonKftInterstitial,
    extraProps: (self) => ({
      selection: self.state.kftInterstitialSelection,
      onSelectionChange: self.setKftInterstitialSelection,
      bookingDialogOpen: self.state.kftBookingDialogOpen,
      onBookingDialogOpenChange: self.setKftBookingDialogOpen,
    }),
  },
  {
    component: CompanyIndustrySelect,
    extraProps: (self) => ({
      selectedIndustry: self.props.company_store?.industry || "",
      industryInput: self.props.company_store?.industryinput || "",
      setIndustrySelection: self.setIndustrySelection,
      setIndustryInput: self.setIndustryInput,
      onCompanyIndustrySelectBack: self.handleCompanyIndustrySelectBack,
      onCompanyIndustrySelectNext: self.handleCompanyIndustrySelectNext,
    }),
  },
  {
    component: CompanyIndustryActivity,
    extraProps: (self) => ({
      onCompanyIndustryActivityNext: self.handleCompanyIndustryActivityNext,
      onCompanyIndustryActivityBack: self.handleCompanyIndustryActivityBack,
    }),
  },
  {
    component: CompanyQuickResult,
    extraProps: (self) => ({
      onCompanyQuickResultBack: self.handleCompanyQuickResultBack,
      onCompanyQuickResultNext: self.handleCompanyQuickResultNext,
    }),
  },
  {
    component: CompanyTaxForm,
    extraProps: (self) => ({
      onInteractedChange: self.handleCompanyTaxFormInteractedChange,
      initialInteracted: self.state.companyTaxFormInteracted,
    }),
  },
  { component: CompanyEmployeeNo },
  { component: CompanyVatStatus },
  {
    component: CompanyRevenue,
    extraProps: (self) => ({
      onCompanyRevenueBack: self.handleCompanyRevenueBack,
      onCompanyRevenueNext: self.handleCompanyRevenueNext,
    }),
  },
  { component: CompanyForeignTrade },
  {
    component: CompanyContactPage,
    extraProps: (self) => ({
      isFillingMethodAutoCompanyContactJump:
        self.state.fillingMethodDidAutoJumpToCompanyContact,
      onFillingMethodAutoCompanyContactBackToFillingMethod:
        self.handleFillingMethodCompanyContactBackToFillingMethod,
      handleBack: self.handleCompanyContactPageBack,
      createAspRequest: self.createAspRequest,
      onRequestError: self.handleContactPageRequestError,
      fetchAspPotentialProviders: self.props.fetchAspPotentialProviders,
      fetchAspTopProvidersByMatchScore: self.props.fetchAspTopProvidersByMatchScore,
      match_score_weights: self.props.match_score_weights,
    }),
  },
  { component: CompanySuccessScreen },
  {
    component: EvIndustrySelect,
    extraProps: (self) => ({
      selectedIndustry: self.props.company_store?.industry || "",
      industryInput: self.props.company_store?.industryinput || "",
      setIndustrySelection: self.setIndustrySelection,
      setIndustryInput: self.setIndustryInput,
      onIndustrySelectNext: self.handleIndustrySelectNext,
      onEvIndustrySelectBack: self.handleEvIndustrySelectBack,
    }),
  },
  {
    component: EvIndustryActivity,
    extraProps: (self) => ({
      onEvIndustryActivityNext: self.handleEvIndustryActivityNext,
      onEvIndustryActivityBack: self.handleEvIndustryActivityBack,
    }),
  },
  {
    component: EvQuickResult,
    extraProps: (self) => ({
      onEvQuickResultBack: self.handleEvQuickResultBack,
      onEvQuickResultNext: self.handleEvQuickResultNext,
    }),
  },
  {
    component: EvTaxForm,
    extraProps: (self) => ({
      onTaxFormNext: self.handleTaxFormNext,
      onTaxFormBack: self.handleTaxFormBack,
      onInteractedChange: self.handleEvTaxFormInteractedChange,
      initialInteracted: self.state.evTaxFormInteracted,
    }),
  },
  { component: EvVatStatus },
  {
    component: EvRevenue,
    extraProps: (self) => ({
      onEvRevenueBack: self.handleEvRevenueBack,
      onEvRevenueNext: self.handleEvRevenueNext,
    }),
  },
  { component: EvForeignTradeStep },
  {
    component: EvContactPage,
    extraProps: (self) => ({
      isFillingMethodAutoContactJump:
        self.state.fillingMethodDidAutoJumpToContact,
      onFillingMethodAutoBackToFillingMethod:
        self.handleFillingMethodContactBackToFillingMethod,
      handleBack: self.handleEvContactPageBack,
      createAspRequest: self.createAspRequest,
      onRequestError: self.handleContactPageRequestError,
      fetchAspPotentialProviders: self.props.fetchAspPotentialProviders,
      fetchAspTopProvidersByMatchScore: self.props.fetchAspTopProvidersByMatchScore,
      match_score_weights: self.props.match_score_weights,
    }),
  },
  { component: EvSuccessScreen },
  { component: GeneralError },
];

const SEARCH_FLOW_STEPS = [
  { component: FirstStep },
  { component: Needs },
  { component: CompanyType },
  { component: Taxform },
  { component: Vat },
  { component: Industry },
  { component: IndustrySpecific },
  { component: Banks },
  { component: Accounts },
  { component: Software },
  { component: ForeignTrade },
  { component: Income },
  { component: InvoicesIn },
  { component: InvoicesOut },
  { component: IndustrySpecificGeneral },
  { component: null }, // IndustrySpecificExtra placeholder
  { component: Languages },
  {
    component: Preferences,
    extraProps: (self) => ({
      fetchAspPotentialProviders: self.props.fetchAspPotentialProviders,
      fetchCherryPotentialProviders: self.props.fetchCherryPotentialProviders,
    }),
  },
  {
    component: FlowSwitch,
    extraProps: (self) => ({
      fetchAspPotentialProviders: self.props.fetchAspPotentialProviders,
      fetchCherryPotentialProviders: self.props.fetchCherryPotentialProviders,
    }),
  },
  {
    component: AspProviders,
    extraProps: (self) => ({
      createAspRequest: self.createAspRequest,
      updateRequest: self.updateRequest,
      reqID: self.state.reqID,
      updateViewedProviders: self.updateViewedProviders,
      handleSearchUpdate: self.handleSearchUpdate,
      discountCode: self.state.discountCode,
      requestCallBack: self.requestCallBack,
    }),
  },
  {
    component: FakeCherryProviders,
    extraProps: (self) => ({
      createAspRequest: self.createAspRequest,
      createRequest: self.createCherryRequest,
      updateRequest: self.updateRequest,
      updateFakeCherryRequest: self.updateFakeCherryRequest,
      reqID: self.state.reqID,
      updateViewedProviders: self.updateViewedProviders,
      handleSearchUpdate: self.handleSearchUpdate,
      discountCode: self.state.discountCode,
      fetchAspPotentialProviders: self.props.fetchAspPotentialProviders,
      requestCallBack: self.requestCallBack,
    }),
  },
];

const STEPS = USE_WIREFRAME_ROUTE ? WIREFRAME_STEPS : SEARCH_FLOW_STEPS;

/** Keep in sync with trackForward/trackBack duration in searchFlow.module.scss (0.25s). */
const STEP_TRANSITION_MS = 250;

const ASP_OFFER_STEP = STEPS.findIndex((s) => s.component === AspProviders);
const CHERRY_OFFER_STEP = STEPS.findIndex(
  (s) => s.component === FakeCherryProviders,
);
const NEEDS_STEP = STEPS.findIndex((s) => s.component === Needs);
const COMPANY_TYPE_STEP = STEPS.findIndex(
  (s) => s.component === (USE_WIREFRAME_ROUTE ? CommonCompanyType : CompanyType),
);
const TAXFORM_STEP = STEPS.findIndex(
  (s) => s.component === (USE_WIREFRAME_ROUTE ? EvTaxForm : Taxform),
);
const VALUE_PROP_STEP = STEPS.findIndex((s) => s.component === CommonValueProp);
const NEW_COMPANY_TYPE_STEP = STEPS.findIndex((s) => s.component === NewCompanyType);

// Helper: Calculate distance between two steps
const getStepIncrement = (fromComponent, toComponent) => {
  const fromIndex = WIREFRAME_STEPS.findIndex(
    (s) => s.component === fromComponent,
  );
  const toIndex = WIREFRAME_STEPS.findIndex((s) => s.component === toComponent);
  return fromIndex >= 0 && toIndex >= 0 ? toIndex - fromIndex : 1;
};

const mapStateToProps = (state) => ({
  store: state,
  loading: state.loading,
  company_store: state.company_store,
  match_score_weights: state.match_score_weights,
  potential_providers: state.company_store.potential_providers,
});
const mapDispatchToProps = (dispatch) => ({
  addCompanyInfo: (item) => dispatch(ACTIONS.addCompanyInfo(item)),
  fetchAspPotentialProviders: (companyData, msWeights) =>
    dispatch(fetchAspPotentialProviders(companyData, msWeights)),
  fetchAspQuickResultSummary: (companyData, msWeights, options) =>
    dispatch(fetchAspQuickResultSummary(companyData, msWeights, options)),
  fetchAspTopProvidersByMatchScore: (companyData, msWeights) =>
    dispatch(fetchAspTopProvidersByMatchScore(companyData, msWeights)),
  fetchCherryPotentialProviders: (companyData, msWeights) =>
    dispatch(fetchCherryPotentialProviders(companyData, msWeights)),
});

class SearchFlowVersionB extends React.Component {
  cegjelzoPersistGeneration = 0;
  analyticsSessionStarted = false;
  flowCompleteTracked = false;
  valuePropReached = false;
  flowAnalytics = null;

  // Set right before we programmatically call window.history.back() for an
  // in-app "back" action, so the resulting popstate is ignored (the step
  // change was already applied synchronously).
  suppressPopOnce = false;

  constructor(props) {
    super(props);
    const initialCompanyType = props.company_store?.companytype || "";
    this.state = {
      activeStep: 0,
      reqID: "",
      cherryID: "",
      searchID: "",
      completedSteps: 0,
      kNetPlusSent: false,
      helpForm: false,
      viewedProviders: [],
      utmzz: Cookies.get("__utmzz") || null,
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      utm_content: "",
      utm_term: "",
      gclid: "",
      dclid: "",
      vacatiOn: false,
      bookkeepie_id: Cookies.get("bookkeepie_id") || null,
      fillingMethodSelection: "auto",
      fillingMethodDidAutoJumpToContact: false,
      fillingMethodDidAutoJumpToCompanyContact: false,
      isQuickResultPrefetching: false,
      companyTypeFlowSelection: initialCompanyType,
      regCompanyTypeSelection: "",
      routingSelection: (() => {
        const answer =
          props.company_store?.answer || props.company_store?.anwser || "";
        if (answer === "existing" || answer === "founding") {
          return answer;
        }
        const stored = props.company_store?.multiplecompany || "";
        if (stored === "singlecompany" || stored === "multiplecompany") {
          return "existing";
        }
        return "";
      })(),
      moreBranchSelection: (() => {
        const stored = props.company_store?.multiplecompany || "";
        if (stored === "singlecompany" || stored === "multiplecompany") {
          return stored;
        }
        return "";
      })(),
      regEntrySource: null,
      stepTransition: null,
      transitionFromStep: null,
      transitionViewportHeight: null,
      aspProgressValue: null,
      aspProgressStep: null,
      cegjelzoPersisting: false,
      cegjelzoPersistError: "",
      evTaxFormInteracted: false,
      companyTaxFormInteracted: false,
      kftInterstitialSelection: "",
      kftCegjelzoInterstitialSelection: "",
      multiCompanyInterstitialSelection: "",
      multiCompanyBookingDialogOpen: false,
      kftBookingDialogOpen: false,
      kftCegjelzoBookingDialogOpen: false,
    };
  }

  getAspProgressStateUpdate = (stepIndex) => {
    const aspProgressValue = computeAspProgressValue(this, stepIndex, STEPS);
    if (aspProgressValue === null) {
      return null;
    }
    return {
      aspProgressValue,
      aspProgressStep: stepIndex,
    };
  };

  syncAspProgressForStep = (stepIndex = this.state.activeStep) => {
    const progressState = this.getAspProgressStateUpdate(stepIndex);
    if (progressState === null) {
      return;
    }
    this.setState(progressState);
  };

  getEffectiveSearchId = () => {
    const id = this.state.searchID || this.props.company_store?.searchID;
    if (!id || id === "undefined" || id === "null") {
      return "";
    }
    return String(id);
  };

  resolveEntryFlow = () => {
    const cs = this.props.company_store || {};
    return normalizeEntryFlowSlug(cs.flowStart || cs.leadtype || "asp");
  };

  initFlowAnalytics = () => {
    if (this.flowAnalytics) {
      return;
    }
    this.flowAnalytics = createSearchFlowAnalytics({
      getSearchId: () => this.getEffectiveSearchId(),
      getSteps: () => STEPS,
      getFlowInstance: () => this,
      entryFlow: this.resolveEntryFlow(),
    });
  };

  isOnValuePropStep = (stepIndex = this.state.activeStep) =>
    VALUE_PROP_STEP >= 0 && stepIndex === VALUE_PROP_STEP;

  /**
   * Terminal analytics on ASP submit. Runs even when the value-prop session gate never
   * opened (e.g. deep-link past value prop), as long as searchID exists.
   */
  trackWireframeReqSentAnalytics = (actualReqID) => {
    const searchId = this.getEffectiveSearchId();
    if (!searchId) {
      return;
    }

    if (!this.analyticsSessionStarted) {
      this.initFlowAnalytics();
      if (this.isOnValuePropStep() || this.valuePropReached) {
        this.flowAnalytics.trackSessionStart(VALUE_PROP_STEP);
        if (!this.isOnValuePropStep()) {
          this.flowAnalytics.trackStepEnterCatchUp(this.state.activeStep);
        }
      }
      this.analyticsSessionStarted = true;
    }

    this.flowCompleteTracked = true;
    const activeComponent = STEPS[this.state.activeStep]?.component;
    this.flowAnalytics.trackReqSent({
      reqId: actualReqID,
      exitFlow: resolveExitFlowSlug({
        activeStepComponent: activeComponent,
        companyStore: this.props.company_store,
        regCompanyTypeSelection: this.state.regCompanyTypeSelection,
      }),
    });
  };

  startFlowAnalyticsSession = () => {
    if (this.analyticsSessionStarted || !USE_WIREFRAME_ROUTE) {
      return;
    }
    if (!this.isOnValuePropStep() && !this.valuePropReached) {
      return;
    }
    const searchId = this.getEffectiveSearchId();
    if (!searchId) {
      return;
    }
    this.initFlowAnalytics();
    this.analyticsSessionStarted = true;
    this.flowAnalytics.trackSessionStart(VALUE_PROP_STEP);
    if (!this.isOnValuePropStep()) {
      this.flowAnalytics.trackStepEnterCatchUp(this.state.activeStep);
    }
  };

  markValuePropReached = () => {
    this.valuePropReached = true;
  };

  beginStepTransition = (fromStep, toStep, direction) => {
    if (VALUE_PROP_STEP >= 0) {
      if (
        fromStep === VALUE_PROP_STEP &&
        direction === "forward"
      ) {
        this.markValuePropReached();
      } else if (toStep === VALUE_PROP_STEP) {
        this.markValuePropReached();
      }
    }

    if (this.stepTransitionTimer) {
      clearTimeout(this.stepTransitionTimer);
    }

    const viewportHeight = this.stepViewportRef
      ? Math.round(this.stepViewportRef.getBoundingClientRect().height)
      : null;

    const progressState = this.getAspProgressStateUpdate(toStep);

    this.setState({
      transitionFromStep: fromStep,
      activeStep: toStep,
      stepTransition: direction,
      transitionViewportHeight: viewportHeight,
      ...(progressState || {}),
    });

    this.stepTransitionTimer = setTimeout(() => {
      this.finishStepTransition();
    }, STEP_TRANSITION_MS + 50);

    if (this.analyticsSessionStarted && this.flowAnalytics) {
      this.flowAnalytics.trackNavigation({
        fromStepIndex: fromStep,
        toStepIndex: toStep,
        direction,
      });
    }
  };

  finishStepTransition = () => {
    if (this.stepTransitionTimer) {
      clearTimeout(this.stepTransitionTimer);
      this.stepTransitionTimer = null;
    }

    if (this.state.transitionFromStep === null) {
      return;
    }

    this.setState({
      transitionFromStep: null,
      stepTransition: null,
      transitionViewportHeight: null,
    });
    window.scrollTo(0, 0);
  };

  handleStepTrackAnimationEnd = (event) => {
    if (event.target === event.currentTarget) {
      return;
    }

    if (!/panelEnter/.test(event.animationName)) {
      return;
    }

    this.finishStepTransition();
  };

  setStepViewportRef = (node) => {
    this.stepViewportRef = node;
  };

  // --- Browser history integration (back/forward navigate within the flow) ---
  // Each forward transition pushes a history entry tagged with the step index;
  // each in-app back consumes one. Pressing the browser back/forward buttons
  // therefore moves between flow steps instead of leaving the page.
  buildFlowHistoryState = (step, isFirst) => ({
    ...(window.history.state || {}),
    sfStep: step,
    sfFirst: isFirst,
  });

  replaceFlowHistoryState = (step, isFirst) => {
    try {
      window.history.replaceState(
        this.buildFlowHistoryState(step, isFirst),
        "",
        window.location.href,
      );
    } catch (e) {
      // history API unavailable — degrade gracefully
    }
  };

  pushFlowHistoryState = (step) => {
    try {
      window.history.pushState(
        this.buildFlowHistoryState(step, false),
        "",
        window.location.href,
      );
    } catch (e) {
      // history API unavailable — degrade gracefully
    }
  };

  // Apply a step change coming from the browser back/forward buttons.
  applyHistoryStepChange = (targetStep) => {
    const fromStep = this.state.activeStep;
    if (targetStep === fromStep) {
      return;
    }
    const direction = targetStep > fromStep ? "forward" : "back";
    this.beginStepTransition(fromStep, targetStep, direction);
    this.props.addCompanyInfo({
      id: "activeStep",
      data: targetStep,
      stateObject: "company_store",
    });
    this.dataLayerUpdate(targetStep, "sf_step_changed");
  };

  handlePopState = (event) => {
    // Ignore the popstate triggered by our own in-app back (history.back()).
    if (this.suppressPopOnce) {
      this.suppressPopOnce = false;
      return;
    }
    const state = event.state;
    // Not one of our flow entries (e.g. navigating away from the flow page) —
    // let the browser / router handle it normally.
    if (!state || typeof state.sfStep !== "number") {
      return;
    }
    this.applyHistoryStepChange(state.sfStep);
  };

  handlePageHide = () => {
    if (!this.flowCompleteTracked && this.analyticsSessionStarted) {
      this.flowAnalytics?.trackAbandonHint();
    }
  };

  // Navigation helpers
  // Move to a specific step component (forward)
  goTo = (target) => {
    const from = STEPS[this.state.activeStep].component;
    this.handleNext(getStepIncrement(from, target));
  };

  // Move back to a specific step component
  goBack = (target) => {
    const from = STEPS[this.state.activeStep].component;
    const fromIndex = WIREFRAME_STEPS.findIndex((s) => s.component === from);
    const toIndex = WIREFRAME_STEPS.findIndex((s) => s.component === target);
    const decr = fromIndex >= 0 && toIndex >= 0 ? fromIndex - toIndex : 1;
    this.handleBack(decr);
  };

  // Reset / set the auto-jump flags before navigation
  setJumpFlags = (toContact, toCompanyContact, cb) => {
    this.setState(
      {
        fillingMethodDidAutoJumpToContact: toContact,
        fillingMethodDidAutoJumpToCompanyContact: toCompanyContact,
      },
      cb,
    );
  };

  // Filling method (common — before company type on manual path)
  setFillingMethodSelection = (selection) => {
    this.setState({ fillingMethodSelection: selection });
  };

  handleFillingMethodBack = () => this.goBack(CommonMoreBranch);

  handleFillingMethodNext = () => {
    if (this.state.fillingMethodSelection === "auto") {
      this.handleFillingMethodAutoNext();
      return;
    }
    this.handleFillingMethodManualNext();
  };

  handleFillingMethodManualNext = () =>
    this.setJumpFlags(false, false, () => this.goTo(CommonCompanyType));

  handleFillingMethodAutoNext = () =>
    this.setJumpFlags(false, false, () => this.goTo(CommonCegjelzoAuto));

  handleCegjelzoAutoBack = () => {
    this.cegjelzoPersistGeneration += 1;
    this.setState({ cegjelzoPersisting: false, cegjelzoPersistError: "" }, () =>
      this.goBack(CommonFillingMethod),
    );
  };

  clearCegjelzoPersistError = () => {
    if (this.state.cegjelzoPersistError) {
      this.setState({ cegjelzoPersistError: "" });
    }
  };

  setCegjelzoPersistError = (message) => {
    this.setState({ cegjelzoPersistError: message });
  };

  isCegjelzoPersistRequestActive = (persistGeneration) =>
    persistGeneration === this.cegjelzoPersistGeneration;

  handleCegjelzoAutoNext = async () => {
    const selectedCompany = this.props.company_store?.cegjelzoData;
    if (
      !selectedCompany ||
      !isCegjelzoRegistryTypeAutoFillSupported(selectedCompany.type)
    ) {
      return;
    }

    const searchID = this.state.searchID || this.props.company_store?.searchID;
    if (!searchID) {
      this.setState({
        cegjelzoPersistError: i18n.t("searchflow.cegjelzonosearchid"),
      });
      return;
    }

    const persistGeneration = ++this.cegjelzoPersistGeneration;
    this.setState({ cegjelzoPersisting: true, cegjelzoPersistError: "" });

    let persisted;
    try {
      persisted = await persistCegjelzoCompany({
        searchID,
        companyData: selectedCompany,
        saveCegjelzoData: this.saveCegjelzoData,
        addCompanyInfo: this.props.addCompanyInfo,
        setCompanyTypeFlowSelection: this.setCompanyTypeFlowSelection,
      });
    } catch (err) {
      console.error("Cegjelzo persist error:", err);
      if (!this.isCegjelzoPersistRequestActive(persistGeneration)) {
        return;
      }
      this.setState({
        cegjelzoPersisting: false,
        cegjelzoPersistError: i18n.t("searchflow.cegjelzosaveerror"),
      });
      return;
    }

    if (!this.isCegjelzoPersistRequestActive(persistGeneration)) {
      return;
    }

    this.setState({ cegjelzoPersisting: false });

    const companytype = persisted?.companytype;
    const registryType = normalizeCegjelzoRegistryType(selectedCompany.type);
    const routeToEvContact =
      registryType === CEGJELZO_REGISTRY_TYPES.SELF_EMPLOYED ||
      (companytype && isEvCompanyType(companytype));

    if (routeToEvContact) {
      this.handleFillingMethodAutoContactNext();
      return;
    }
    this.handleFillingMethodAutoCompanyContactNext();
  };

  // Cegjelzo auto-fill → EV tax form (then contact page)
  handleFillingMethodAutoContactNext = () =>
    this.setJumpFlags(false, false, () => this.goTo(EvCegjelzoTaxForm));

  // Cegjelzo auto-fill → company tax form (then contact page). "kft" gets an
  // extra consultation interstitial first — same as the manual pick path.
  handleFillingMethodAutoCompanyContactNext = () => {
    const companytype = this.props.company_store?.companytype;
    const target =
      companytype === "kft" ? CommonKftCegjelzoInterstitial : CompanyCegjelzoTaxForm;
    this.setJumpFlags(false, false, () => this.goTo(target));
  };

  handleEvCegjelzoTaxFormBack = () => this.goBack(CommonCegjelzoAuto);

  handleEvCegjelzoTaxFormNext = () => {
    if (!isEntrepreneurTaxCompanyType(this.props.company_store?.companytype)) {
      return;
    }
    this.setJumpFlags(true, false, () => this.goTo(EvContactPage));
  };

  handleKftCegjelzoInterstitialNext = () => {
    const selection = this.state.kftCegjelzoInterstitialSelection;
    this.recordConsultationChoice({
      selection,
      stepId: "common_kft_cegjelzo_interstitial",
      contextKey: "kftCegjelzoInterstitialSelection",
    });
    if (selection === "consultation") {
      this.setKftCegjelzoBookingDialogOpen(true);
      return;
    }
    this.setJumpFlags(false, false, () => this.goTo(CompanyCegjelzoTaxForm));
  };
  handleKftCegjelzoInterstitialBack = () => this.goBack(CommonCegjelzoAuto);

  handleCompanyCegjelzoTaxFormBack = () => {
    const companytype = this.props.company_store?.companytype;
    this.goBack(
      companytype === "kft" ? CommonKftCegjelzoInterstitial : CommonCegjelzoAuto,
    );
  };

  handleCompanyCegjelzoTaxFormNext = () =>
    this.setJumpFlags(false, true, () => this.goTo(CompanyContactPage));

  handleFillingMethodContactBackToFillingMethod = () =>
    this.setJumpFlags(false, false, () => this.goBack(EvCegjelzoTaxForm));

  handleFillingMethodCompanyContactBackToFillingMethod = () =>
    this.setJumpFlags(false, false, () => this.goBack(CompanyCegjelzoTaxForm));

  // Cegjelzo data
  saveCegjelzoData = (companyData) => {
    this.props.addCompanyInfo({
      id: "cegjelzoData",
      data: companyData,
      stateObject: "company_store",
    });
  };

  clearCegjelzoData = () => {
    this.props.addCompanyInfo({
      id: "cegjelzoData",
      data: null,
      stateObject: "company_store",
    });
  };

  persistRoutingAnswer = (answer) => {
    const isExisting = answer === "existing";
    const flags = isExisting
      ? {
          answer: "existing",
          accounting: true,
          newlyfounded: false,
          legalentityfounding: false,
          taxconsultingcomplex: false,
          taxconsultingsimple: false,
        }
      : {
          answer: "founding",
          accounting: false,
          newlyfounded: true,
          legalentityfounding: true,
          taxconsultingcomplex: false,
          taxconsultingsimple: false,
        };

    Object.entries(flags).forEach(([id, data]) => {
      this.props.addCompanyInfo({
        id,
        data,
        stateObject: "company_store",
      });
    });
    // SearchSchema has no standalone `accounting`/`legalentityfounding` field —
    // services only persist inside the `services` array. Mirror it into
    // company_store.services too (not just the search-doc patch below):
    // updateSearchData() patches `{...company_store}` wholesale on every step
    // change, so a stale/empty redux value would otherwise wipe this out.
    const services = isExisting ? ["accounting"] : ["legalentityfounding"];
    this.props.addCompanyInfo({
      id: "services",
      data: services,
      stateObject: "company_store",
    });
    this.persistAnswer(answer, services);
  };

  persistAnswer = (answer, services) => {
    const searchID =
      this.state.searchID || this.props.company_store?.searchID;
    if (
      !searchID ||
      searchID === "undefined" ||
      searchID === "null"
    ) {
      return;
    }

    axios
      .patch(
        `/api/search/${searchID}`,
        services ? { answer, services } : { answer },
        { headers: { "Content-Type": "application/json" } },
      )
      .catch((error) => {
        console.error(
          "Error saving answer to search:",
          error.response?.data || error.message,
        );
      });
  };

  // Routing (existing business vs founding)
  setRoutingSelection = (value) => {
    if (value === "founding") {
      this.setState({ routingSelection: value, moreBranchSelection: "" });
      this.persistRoutingAnswer("founding");
      this.props.addCompanyInfo({
        id: "multiplecompany",
        data: "",
        stateObject: "company_store",
      });
      this.persistMultiplecompany("");
      return;
    }

    if (value === "existing") {
      const stored = this.props.company_store?.multiplecompany || "";
      const hasBranchChoice =
        stored === "singlecompany" || stored === "multiplecompany";

      this.setState({
        routingSelection: value,
        ...(hasBranchChoice ? {} : { moreBranchSelection: "" }),
      });
      this.persistRoutingAnswer("existing");
    }
  };

  // Business count (single vs multiple under existing-business path)
  setMoreBranchSelection = (value) => {
    this.setState({ moreBranchSelection: value });

    if (value === "singlecompany" || value === "multiplecompany") {
      this.props.addCompanyInfo({
        id: "multiplecompany",
        data: value,
        stateObject: "company_store",
      });
      this.persistMultiplecompany(value);
    }
  };

  persistMultiplecompany = (multiplecompany) => {
    const searchID =
      this.state.searchID || this.props.company_store?.searchID;
    if (
      !searchID ||
      searchID === "undefined" ||
      searchID === "null"
    ) {
      return;
    }

    axios
      .patch(
        `/api/search/${searchID}`,
        { multiplecompany },
        { headers: { "Content-Type": "application/json" } },
      )
      .catch((error) => {
        console.error(
          "Error saving multiplecompany to search:",
          error.response?.data || error.message,
        );
      });
  };

  // Consultation-interstitial selections (frontend-only UI state, not persisted).
  setKftInterstitialSelection = (value) => this.setState({ kftInterstitialSelection: value });
  setKftCegjelzoInterstitialSelection = (value) =>
    this.setState({ kftCegjelzoInterstitialSelection: value });
  setMultiCompanyInterstitialSelection = (value) =>
    this.setState({ multiCompanyInterstitialSelection: value });
  setMultiCompanyBookingDialogOpen = (value) =>
    this.setState({ multiCompanyBookingDialogOpen: value });
  setKftBookingDialogOpen = (value) => this.setState({ kftBookingDialogOpen: value });
  setKftCegjelzoBookingDialogOpen = (value) =>
    this.setState({ kftCegjelzoBookingDialogOpen: value });

  // Persists the user's final "book consultation vs. continue" choice at a
  // consultation interstitial: mirrors it into company_store (for aspRequest
  // submission later) and fires a choice_recorded analytics event (for
  // search.flowAnalytics.consultationChoice) — fired uniformly regardless of
  // which branch the caller is about to take.
  recordConsultationChoice = ({ selection, stepId, contextKey }) => {
    this.props.addCompanyInfo({
      id: "consultationChoice",
      data: selection === "consultation" ? "consultation" : "selfservice",
      stateObject: "company_store",
    });
    if (this.analyticsSessionStarted && this.flowAnalytics) {
      this.flowAnalytics.trackChoice({
        stepId,
        context: { [contextKey]: selection },
      });
    }
  };

  persistLeadType = (leadtype, companytype = null) => {
    const abVersion = this.props.company_store?.abVersion || "B";

    this.props.addCompanyInfo({
      id: "leadtype",
      data: leadtype,
      stateObject: "company_store",
    });
    this.props.addCompanyInfo({
      id: "abVersion",
      data: abVersion,
      stateObject: "company_store",
    });
    if (companytype !== null) {
      this.props.addCompanyInfo({
        id: "companytype",
        data: companytype,
        stateObject: "company_store",
      });
    }

    const searchID =
      this.state.searchID || this.props.company_store?.searchID;
    if (
      !searchID ||
      searchID === "undefined" ||
      searchID === "null"
    ) {
      return;
    }

    axios
      .patch(
        `/api/search/${searchID}`,
        companytype !== null
          ? { leadtype, abVersion, companytype }
          : { leadtype, abVersion },
        { headers: { "Content-Type": "application/json" } },
      )
      .catch((error) => {
        console.error(
          "Error saving leadtype to search:",
          error.response?.data || error.message,
        );
      });
  };

  handleRoutingNext = () => {
    const { routingSelection } = this.state;
    if (routingSelection === "existing") {
      this.goTo(CommonMoreBranch);
      return;
    }
    if (routingSelection === "founding") {
      this.goTo(NewCompanyType);
    }
  };

  handleRoutingBack = () => this.goBack(CommonValueProp);

  handleNewCompanyTypeBack = () => this.goBack(CommonRouting);

  handleNewCompanyTypeNext = () => {
    const target = this.state.regCompanyTypeSelection;
    const leadtype =
      target === "vaf" ? "VAF" : target === "kftreg" ? "KFTREG" : "REG";
    // Kft is the only branch with a single, fixed company type — reg leaves it to
    // RegTaxForm's own pick (singleprimary/singlesecondary/kiva/vszja), and vaf has
    // no fixed type at all (that's the "not sure which form" branch).
    const companytype = target === "kftreg" ? "kft" : null;
    this.persistLeadType(leadtype, companytype);

    // Carry the existing searchID across this hard navigation (company_store
    // doesn't survive a full page load) so the destination flow's
    // ensureSearchExists() resumes this same search instead of creating a new one.
    const searchID = this.state.searchID || this.props.company_store?.searchID;
    const searchIDParam = searchID ? `&searchID=${searchID}` : "";

    if (target === "vaf") {
      this.trackRegFlowHandoff();
      window.location.assign(`/company/request/vafb?entry=newCompanyType${searchIDParam}`);
      return;
    }
    if (target === "kftreg") {
      this.trackRegFlowHandoff();
      window.location.assign(`/company/request/kftregb?entry=newCompanyType${searchIDParam}`);
      return;
    }
    this.trackRegFlowHandoff();
    window.location.assign(`/company/request/regb?entry=newCompanyType${searchIDParam}`);
  };

  handleMoreBranchNext = () => {
    const { moreBranchSelection } = this.state;
    if (moreBranchSelection === "multiplecompany") {
      this.goTo(NewMultiCompanyInterstitial);
      return;
    }
    if (moreBranchSelection === "singlecompany") {
      this.goTo(CommonFillingMethod);
    }
  };

  handleMoreBranchBack = () => this.goBack(CommonRouting);

  handleMultiCompanyInterstitialBack = () => this.goBack(CommonMoreBranch);

  handleMultiCompanyInterstitialNext = () => {
    const selection = this.state.multiCompanyInterstitialSelection;
    this.recordConsultationChoice({
      selection,
      stepId: "new_multi_company_interstitial",
      contextKey: "multiCompanyInterstitialSelection",
    });
    if (selection === "consultation") {
      this.setMultiCompanyBookingDialogOpen(true);
      return;
    }
    this.flowCompleteTracked = true;
    if (this.analyticsSessionStarted && this.flowAnalytics) {
      this.flowAnalytics.trackFlowHandoff({ exitFlow: "multicompany" });
    }
    window.location.assign(TYPEFORM_MULTIPLE_BUSINESSES_URL);
  };

  // Company type
  mapFlowSelectionToCompanyType = (selection) => {
    if (
      selection === "reg_industry_select" ||
      selection === "other" ||
      selection === "company"
    ) {
      return "";
    }
    if (selection === "entrepreneur") {
      return "singlesecondary";
    }
    return selection;
  };

  isCompanyFlowSelection = (selection) =>
    [
      "company",
      "bt",
      "kft",
      "other",
      "zrt",
      "kkt",
      "nyrt",
      "condo",
      "citycouncil",
      "civil",
    ].includes(selection);

  setCompanyTypeFlowSelection = (value, callback) => {
    const companyTypeValue = this.mapFlowSelectionToCompanyType(value);
    this.setState(
      {
        companyTypeFlowSelection: value,
        // Changing the top-level company type reassigns a new companytype/taxform
        // default further down the flow, so any earlier taxform "interacted" state
        // is stale and must not carry over.
        evTaxFormInteracted: false,
        companyTaxFormInteracted: false,
      },
      callback,
    );
    this.props.addCompanyInfo({
      id: "companytype",
      data: companyTypeValue,
      stateObject: "company_store",
    });
  };

  handleCompanyTypeBack = () => this.goBack(CommonFillingMethod);

  handleCompanyTypeSoleProprietorshipNext = () => {
    this.setCompanyTypeFlowSelection("entrepreneur", () => this.goTo(EvIndustrySelect));
  };

  handleCompanyTypeCompanyNext = () => {
    this.goTo(CompanyIndustrySelect);
  };

  handleCompanyTypeKftNext = () => this.goTo(CommonKftInterstitial);

  handleKftInterstitialNext = () => {
    const selection = this.state.kftInterstitialSelection;
    this.recordConsultationChoice({
      selection,
      stepId: "common_kft_interstitial",
      contextKey: "kftInterstitialSelection",
    });
    if (selection === "consultation") {
      this.setKftBookingDialogOpen(true);
      return;
    }
    this.goTo(CompanyIndustrySelect);
  };
  handleKftInterstitialBack = () => this.goBack(CommonCompanyType);

  handleCompanyTypeRegIndustrySelectNext = () => {
    this.setCompanyTypeFlowSelection("reg_industry_select", () => {
      const searchID = this.state.searchID || this.props.company_store?.searchID;
      const searchIDParam = searchID ? `&searchID=${searchID}` : "";
      window.location.assign(`/company/request/regb?regEntry=companytype${searchIDParam}`);
    });
  };

  setRegCompanyTypeSelection = (value) => {
    this.setState({ regCompanyTypeSelection: value });
  };

  trackRegFlowHandoff = () => {
    if (!this.analyticsSessionStarted || !this.flowAnalytics) {
      return;
    }
    const selection = this.state.regCompanyTypeSelection;
    const exitFlow =
      selection === "vaf" ? "vaf" : selection === "kftreg" ? "kftreg" : "reg";
    this.flowCompleteTracked = true;
    this.flowAnalytics.trackFlowHandoff({ exitFlow });
  };

  setIndustrySelection = (industry) => {
    return persistIndustryWithFinancialDefaults({
      industry,
      searchID: this.state.searchID || this.props.company_store?.searchID,
      addCompanyInfo: this.props.addCompanyInfo,
      clearIndustryInputWhenNotOther: true,
    }).catch((error) => {
      console.error(
        "Error saving industry financial defaults to searchSchema:",
        error.response?.data || error.message,
      );
      throw error;
    });
  };

  setIndustryInput = (value) => {
    this.props.addCompanyInfo({
      id: "industryinput",
      data: value,
      stateObject: "company_store",
    });
  };

  // Industry / Tax navigation
  evIndustryShowsActivityStep = () =>
    evIndustryHasActivityContent(this.props.company_store?.industry);

  prefetchQuickResultAndGo = (targetStep) => {
    if (this.state.isQuickResultPrefetching) {
      return;
    }

    this.setState({ isQuickResultPrefetching: true });

    prefetchAspQuickResult({
      fetchAspPotentialProviders: this.props.fetchAspPotentialProviders,
      fetchAspQuickResultSummary: this.props.fetchAspQuickResultSummary,
      companyStore: this.props.company_store,
      matchScoreWeights: this.props.match_score_weights,
    })
      .then(() => {
        this.goTo(targetStep);
      })
      .catch((error) => {
        console.log("Quick result prefetch error:", error);
        this.goTo(targetStep);
      })
      .finally(() => {
        this.setState({ isQuickResultPrefetching: false });
      });
  };

  handleIndustrySelectNext = () => {
    if (this.evIndustryShowsActivityStep()) {
      this.goTo(EvIndustryActivity);
    } else {
      this.prefetchQuickResultAndGo(EvQuickResult);
    }
  };
  handleEvIndustryActivityNext = () => this.prefetchQuickResultAndGo(EvQuickResult);
  handleEvIndustryActivityBack = () => this.goBack(EvIndustrySelect);
  handleEvQuickResultBack = () => {
    if (this.evIndustryShowsActivityStep()) {
      this.goBack(EvIndustryActivity);
    } else {
      this.goBack(EvIndustrySelect);
    }
  };
  handleEvQuickResultNext = () => this.goTo(EvTaxForm);
  handleEvVatStatusBack = () => this.goBack(EvTaxForm);
  handleEvVatStatusNext = () => this.goTo(EvRevenue);
  handleEvRevenueBack = () => this.goBack(EvVatStatus);
  handleEvIndustrySelectBack = () => this.goBack(CommonCompanyType);

  evIndustryShowsForeignTradeStep = () =>
    evIndustryHasForeignTradeStep(this.props.company_store?.industry);

  handleEvRevenueNext = () => {
    if (this.evIndustryShowsForeignTradeStep()) {
      this.goTo(EvForeignTradeStep);
    } else {
      this.goTo(EvContactPage);
    }
  };
  handleEvForeignTradeBack = () => this.goBack(EvRevenue);
  handleEvForeignTradeNext = () => this.goTo(EvContactPage);
  handleEvContactPageBack = () => {
    if (this.evIndustryShowsForeignTradeStep()) {
      this.goBack(EvForeignTradeStep);
    } else {
      this.goBack(EvRevenue);
    }
  };

  companyIndustryShowsActivityStep = () =>
    companyIndustryHasActivityContent(this.props.company_store?.industry);

  handleCompanyIndustrySelectNext = () => {
    if (this.companyIndustryShowsActivityStep()) {
      this.goTo(CompanyIndustryActivity);
    } else {
      this.prefetchQuickResultAndGo(CompanyQuickResult);
    }
  };
  handleCompanyIndustrySelectBack = () => {
    const selection = this.state.companyTypeFlowSelection;
    this.goBack(selection === "kft" ? CommonKftInterstitial : CommonCompanyType);
  };
  handleCompanyIndustryActivityNext = () =>
    this.prefetchQuickResultAndGo(CompanyQuickResult);
  handleCompanyIndustryActivityBack = () => this.goBack(CompanyIndustrySelect);
  handleCompanyQuickResultBack = () => {
    if (this.companyIndustryShowsActivityStep()) {
      this.goBack(CompanyIndustryActivity);
    } else {
      this.goBack(CompanyIndustrySelect);
    }
  };
  handleCompanyQuickResultNext = () => this.goTo(CompanyTaxForm);
  handleCompanyVatStatusBack = () => this.goBack(CompanyEmployeeNo);
  handleCompanyVatStatusNext = () => this.goTo(CompanyRevenue);

  companyIndustryShowsForeignTradeStep = () =>
    companyIndustryHasForeignTradeStep(this.props.company_store?.industry);

  handleCompanyRevenueBack = () => this.goBack(CompanyVatStatus);
  handleCompanyRevenueNext = () => {
    if (this.companyIndustryShowsForeignTradeStep()) {
      this.goTo(CompanyForeignTrade);
    } else {
      this.goTo(CompanyContactPage);
    }
  };
  handleCompanyForeignTradeBack = () => this.goBack(CompanyRevenue);
  handleCompanyForeignTradeNext = () => this.goTo(CompanyContactPage);
  handleCompanyContactPageBack = () => {
    if (this.companyIndustryShowsForeignTradeStep()) {
      this.goBack(CompanyForeignTrade);
    } else {
      this.goBack(CompanyRevenue);
    }
  };

  /** Shown when the ASP request fails to send from either contact page (no reqID / network error). */
  handleContactPageRequestError = () => {
    this.goTo(GeneralError);
  };

  handleTaxFormNext = () => {
    if (!isEntrepreneurTaxCompanyType(this.props.company_store?.companytype)) {
      return;
    }
    this.goTo(EvVatStatus);
  };
  handleTaxFormBack = () => this.goBack(EvQuickResult);
  /** Frontend-only guard: Next stays disabled until the user picks on this screen, even if companytype already has a stored default. */
  handleEvTaxFormInteractedChange = (hasInteracted) => {
    if (this.state.evTaxFormInteracted !== hasInteracted) {
      this.setState({ evTaxFormInteracted: hasInteracted });
    }
  };

  handleCompanyTaxFormNext = () => this.goTo(CompanyEmployeeNo);
  handleCompanyTaxFormBack = () => this.goBack(CompanyQuickResult);
  /** Frontend-only guard: Next stays disabled until the user picks on this screen, even if taxform already has a stored default. */
  handleCompanyTaxFormInteractedChange = (hasInteracted) => {
    if (this.state.companyTaxFormInteracted !== hasInteracted) {
      this.setState({ companyTaxFormInteracted: hasInteracted });
    }
  };

  handleCompanyEmployeeNoBack = () => this.goBack(CompanyTaxForm);
  handleCompanyEmployeeNoNext = () => this.goTo(CompanyVatStatus);

  dataLayerUpdate(stepData, event) {
    window.dataLayer.push({
      event: event,
      step: stepData,
      event_category: "aspflow",
    });
  }

  dataLayerVersionUpdate() {
    pushFlowContextToDataLayer({
      version: "B",
      flow: "aspflow",
      company_store: this.props.company_store,
    });
  }

  syncServicesWithAccounting = () => {
    const { company_store, addCompanyInfo } = this.props;
    const currentServices = Array.isArray(company_store.services)
      ? company_store.services
      : typeof company_store.services === "string" && company_store.services.trim()
        ? company_store.services
          .split(",")
          .map((service) => service.trim())
          .filter(Boolean)
        : [];
    const hasAccounting = currentServices.includes("accounting");

    if (company_store.accounting && !hasAccounting) {
      addCompanyInfo({
        id: "services",
        data: [...currentServices, "accounting"],
        stateObject: "company_store",
      });
      return;
    }

    if (!company_store.accounting && hasAccounting) {
      addCompanyInfo({
        id: "services",
        data: currentServices.filter((service) => service !== "accounting"),
        stateObject: "company_store",
      });
    }
  };

  bkIdDataLayerUpdate(stepData, event) {
    window.dataLayer.push({
      event: event,
      bookkeepie_id: stepData,
      event_category: "aspflow",
    });
  }

  componentDidMount() {
    let bkID = Cookies.get("bookkeepie_id");
    const { company_store, addCompanyInfo } = this.props;

    window.addEventListener("popstate", this.handlePopState);
    window.addEventListener("pagehide", this.handlePageHide);

    // Sync UTMs from Redux (populated by CompanyLayout UTM bootstrap)
    if (
      company_store.utm_source ||
      company_store.utm_medium ||
      company_store.utm_campaign
    ) {
      this.setState({
        utm_source: company_store.utm_source || "",
        utm_medium: company_store.utm_medium || "",
        utm_campaign: company_store.utm_campaign || "",
        utm_content: company_store.utm_content || "",
        utm_term: company_store.utm_term || "",
        gclid: company_store.gclid || "",
        dclid: company_store.dclid || "",
      });
    }

    addCompanyInfo({
      id: "abVersion",
      data: "B",
      stateObject: "company_store",
    });
    this.syncServicesWithAccounting();

    // syncServicesWithAccounting() dispatches the corrected `services` array,
    // but that redux update isn't reflected in the `company_store` local
    // variable captured above (same-tick dispatches don't update this.props
    // synchronously) — so ensureSearchExists() below would otherwise POST a
    // brand-new search with a stale/empty `services`. Recompute it inline so a
    // freshly-created search is correct from the start, not just after the
    // user later reaches a step that re-patches it.
    const existingServices = Array.isArray(company_store.services)
      ? company_store.services
      : [];
    const servicesForSearch =
      company_store.accounting && !existingServices.includes("accounting")
        ? [...existingServices, "accounting"]
        : existingServices;

    // A hard-navigation return trip from reg/kftreg/vaf's IndustrySelect "Back" button
    // (?resumeStep=newCompanyType) lands the user back on NewCompanyType without having
    // re-picked a company type yet — the REG/KFTREG/VAF `leadtype` persistLeadType() set
    // on the way OUT is now stale and must be reset, or an abandoned session (no
    // resubmission) leaves the search doc permanently mislabeled.
    const isResumingFromSubFlowReturn =
      new URLSearchParams(window.location.search).get("resumeStep") === "newCompanyType";

    // Ensure search exists (creates only if company_store.searchID empty; uses UTMs from Redux)
    ensureSearchExists({
      flowType: "ASP",
      abVersion: "B",
      company_store: { ...company_store, services: servicesForSearch },
      addCompanyInfo,
      step: this.state.activeStep + 1,
    }).then((searchID) => {
      if (searchID) {
        this.setState({ searchID }, () => {
          if (isResumingFromSubFlowReturn) {
            this.persistLeadType("ASP");
          }
        });
      }
    });

    const selectedSP = localStorage.getItem("selectedSP");
    selectedSP &&
      addCompanyInfo({
        id: "spSelectedFromList",
        data: selectedSP,
        stateObject: "company_store",
      });
    this.dataLayerUpdate(0, "sf_step_changed");
    this.dataLayerVersionUpdate();
    let cookie = document.cookie;
    if (!cookie.includes("reqsent")) {
      document.cookie = "reqsent=false";
    }
    if (!bkID) {
      bkID = uuidv4();
      this.setState({ bookkeepie_id: bkID });
      Cookies.set("bookkeepie_id", bkID, { expires: 90 });
      this.props.addCompanyInfo({
        id: "searchUser",
        data: bkID,
        stateObject: "company_store",
      });
      axios
        .post(
          `/api/searchUser`,
          {
            userID: bkID,
            searches: [],
            reqs: [],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          // console.log("AXIOS RESPONSE: ", response);
        })
        .catch((error) => {
          console.log("AXIOS ERROR: ", error.response.data);
        });
    } else {
      this.props.addCompanyInfo({
        id: "searchUser",
        data: bkID,
        stateObject: "company_store",
      });
    }
    this.bkIdDataLayerUpdate(bkID, "sf_step_bookkeepie_id");

    const urlParams = new URLSearchParams(window.location.search);
    const urlExisting = urlParams.get("existing");
    const urlCompanytype = urlParams.get("companytype");

    if (urlCompanytype === "bt" || urlCompanytype === "kft") {
      this.persistRoutingAnswer("founding");
      this.props.addCompanyInfo({
        id: "companytype",
        data: urlCompanytype,
        stateObject: "company_store",
      });
      this.setState(
        {
          companyTypeFlowSelection: urlCompanytype,
          activeStep: TAXFORM_STEP,
          routingSelection: "founding",
          moreBranchSelection: "",
        },
        () => this.syncAspProgressForStep(TAXFORM_STEP),
      );
      this.replaceFlowHistoryState(TAXFORM_STEP, true);
    } else if (urlExisting === "true") {
      this.persistRoutingAnswer("existing");
      this.props.addCompanyInfo({
        id: "multiplecompany",
        data: "singlecompany",
        stateObject: "company_store",
      });
      this.persistMultiplecompany("singlecompany");
      this.setState(
        {
          activeStep: COMPANY_TYPE_STEP,
          routingSelection: "existing",
          moreBranchSelection: "singlecompany",
        },
        () => this.syncAspProgressForStep(COMPANY_TYPE_STEP),
      );
      this.replaceFlowHistoryState(COMPANY_TYPE_STEP, true);
    } else if (urlParams.get("resumeStep") === "newCompanyType") {
      // Back button from vaf/reg/kftreg's IndustrySelect (when reached via
      // NewCompanyType) lands here instead of dropping the user at the flow start.
      // This resumes an existing funnel session (searchID carried over via URL
      // param) past the value-prop gate — mark it reached so the analytics
      // session resumes immediately instead of staying dark until some other
      // state change happens to trigger the sync.
      this.markValuePropReached();
      this.setState(
        {
          activeStep: NEW_COMPANY_TYPE_STEP,
          routingSelection: "founding",
        },
        () => this.syncAspProgressForStep(NEW_COMPANY_TYPE_STEP),
      );
      this.replaceFlowHistoryState(NEW_COMPANY_TYPE_STEP, true);
    } else {
      this.syncAspProgressForStep(this.state.activeStep);
      this.replaceFlowHistoryState(this.state.activeStep, true);
    }
  }

  componentWillUnmount() {
    if (this.stepTransitionTimer) {
      clearTimeout(this.stepTransitionTimer);
    }
    window.removeEventListener("popstate", this.handlePopState);
    window.removeEventListener("pagehide", this.handlePageHide);
  }

  syncFlowAnalyticsSession = (prevProps, prevState) => {
    if (this.isOnValuePropStep()) {
      this.markValuePropReached();
    }

    if (this.analyticsSessionStarted || !this.getEffectiveSearchId()) {
      return;
    }
    if (!this.isOnValuePropStep() && !this.valuePropReached) {
      return;
    }

    const searchOrStepChanged =
      prevState.searchID !== this.state.searchID ||
      prevProps.company_store?.searchID !== this.props.company_store?.searchID ||
      prevState.activeStep !== this.state.activeStep;

    // Retry while on value prop so a missed start (e.g. mid-flow entry then back)
    // is not lost when only transition UI state clears on the next update.
    if (searchOrStepChanged || this.isOnValuePropStep()) {
      this.startFlowAnalyticsSession();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.company_store?.accounting !== this.props.company_store?.accounting
    ) {
      this.syncServicesWithAccounting();
    }
    this.syncFlowAnalyticsSession(prevProps, prevState);
    this.handleSearchUpdate(prevState.activeStep);
    let bkID = Cookies.get("bookkeepie_id");
    // Only register the search under the user when the searchID actually changes,
    // otherwise this fires a /api/searchUser GET on every single re-render.
    if (bkID && prevState.searchID !== this.state.searchID) {
      let searchList = [];
      axios
        .get(`/api/searchUser/${bkID}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          searchList = response.data.searchUser.searches.filter(
            (value) => value !== null,
          );
          const sid = this.state.searchID;
          const sidStr = sid && String(sid).trim();
          if (sidStr && !searchList.some((s) => String(s) === sidStr)) {
            searchList.push(sidStr);
            let uniques = [
              ...new Set(
                searchList.filter((item) => String(item).trim() !== ""),
              ),
            ];
            axios.patch(
              `/api/searchUser/${bkID}`,
              { searches: uniques },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              },
            );
          }
        })
        .catch((error) => {
          console.log(
            "AXIOS ERROR COMPUPDATE: ",
            error.response || error.message,
          );
          console.log("Bookkeepie ID:", bkID);
        });
    }
    if (
      this.state.completedSteps >= ASP_OFFER_STEP &&
      checkStateChange(prevProps.company_store, this.props.company_store) ===
      true
      // && this.checkServices() === true
    ) {
      this.props.fetchAspPotentialProviders(
        this.props.company_store,
        this.props.match_score_weights,
      );
    }
    if (
      this.state.completedSteps >= CHERRY_OFFER_STEP &&
      this.state.reqID.length > 0 &&
      checkStateChange(prevProps.company_store, this.props.company_store)
      // && this.checkServices() === true
    ) {
      //this.setState({ reqID: '' });
      this.props.addCompanyInfo({
        id: "selected_providers",
        data: [],
        stateObject: "company_store",
      });
    }
  }

  handleNext = (increment = 1) => {
    // Guard: if called as event handler directly, ignore the event arg
    if (typeof increment !== "number") increment = 1;
    if (this.state.transitionFromStep !== null) {
      return;
    }
    if (this.state.activeStep < STEPS.length) {
      const fromStep = this.state.activeStep;
      const toStep = fromStep + increment;

      if (this.state.searchID === "") {
        this.submitSearchData();
      }
      this.beginStepTransition(fromStep, toStep, "forward");
      this.dataLayerUpdate(toStep, "sf_step_changed");
      if (this.state.completedSteps < toStep) {
        this.setState({
          completedSteps: this.state.completedSteps + increment,
        });
      }

      // Preserve the previous behavior: run when leaving the Needs step.
      if (fromStep === NEEDS_STEP && increment === 1) {
        const utmMedium = this.props.company_store.utm_medium;
        const utmCampaign = this.props.company_store.utm_campaign;

        if (utmMedium === "referral" && utmCampaign) {
          console.log(
            "UTM referral detected on step transition, setting discount code:",
            utmCampaign,
          );
          this.props.addCompanyInfo({
            id: "discountCode",
            data: utmCampaign,
            stateObject: "company_store",
          });
        }
      }

      this.props.addCompanyInfo({
        id: "activeStep",
        data: toStep,
        stateObject: "company_store",
      });

      // Add a browser history entry so the back button returns to this step.
      this.pushFlowHistoryState(toStep);
    }
  };
  handleBack = (decr = 1) => {
    if (typeof decr !== "number") decr = 1;
    if (this.state.transitionFromStep !== null) {
      return;
    }
    if (this.state.activeStep !== 0) {
      const fromStep = this.state.activeStep;
      const toStep = fromStep - decr;
      this.beginStepTransition(fromStep, toStep, "back");
      this.props.addCompanyInfo({
        id: "activeStep",
        data: toStep,
        stateObject: "company_store",
      });

      // Keep the browser history in sync. If we're already at the first flow
      // entry (e.g. entered mid-flow via a URL param) there is nothing to pop,
      // so just update the current entry instead of leaving the page.
      const histState = window.history.state;
      if (!histState || histState.sfFirst) {
        this.replaceFlowHistoryState(toStep, true);
      } else {
        this.suppressPopOnce = true;
        window.history.back();
      }
    }
  };
  handleTracker = (step) => {
    this.setState({ activeStep: step }, () => this.syncAspProgressForStep(step));
  };
  handleKnetPlusContact = () => {
    this.setState({ kNetPlusSent: true });
  };
  openHelpForm = () => {
    this.setState({ helpForm: true });
  };
  closeHelpForm = () => {
    this.setState({ helpForm: false });
  };
  createAspRequest = (companyData) => {
    let data = prepareAspPayload(companyData, {
      searchID:
        this.state.searchID ||
        this.props.company_store?.searchID ||
        companyData.searchID ||
        "",
      abVersion: this.props.company_store.abVersion || "B",
    });
    if (data.noofemployees === "") {
      data.noofemployees = 0;
    }
    if (data.incominginvoices === "") {
      data.incominginvoices = 0;
    }
    if (data.outgoinginvoices === "") {
      data.outgoinginvoices = 0;
    }
    // reg/vaf/kftreg submissions set callbacksource (see RegistrationContactPage.jsx) to
    // route through the callback endpoint, which is what triggers their flow-specific
    // customer emails ("Company - REG/VAF/KFT REG RFP Details") and the internal
    // "REG/VAF igénylés" notification — the plain /api/aspreq endpoint only ever sends
    // the generic ASP accountant-matching emails, regardless of leadtype.
    const endpoint = data.callbacksource
      ? "/api/aspreq/requestcallback/new"
      : "/api/aspreq";
    return axios
      .post(endpoint, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        sessionStorage.setItem("reqEmail", data.email);
        const reqID = response.data.result._id;
        const searchID = response.data.searchID || this.state.searchID;

        console.log("ASP Request created successfully:", {
          reqID: reqID,
          searchID: searchID,
          backendSearchID: response.data.searchID,
          existingSearchID: this.state.searchID,
        });

        return new Promise((resolve, reject) => {
          try {
            this.setState({ reqID: reqID }, () => {
              this.props.addCompanyInfo({
                id: "reqID",
                data: reqID,
                stateObject: "company_store",
              });

              const finish = () => {
                this.handleSearchRequestSent(reqID);
                resolve(response);
              };

              if (response.data.searchID && !this.state.searchID) {
                this.setState({ searchID: response.data.searchID }, () => {
                  this.props.addCompanyInfo({
                    id: "searchID",
                    data: response.data.searchID,
                    stateObject: "company_store",
                  });
                  finish();
                });
              } else {
                finish();
              }
            });
          } catch (err) {
            reject(err);
          }
        });
      })
      .catch((error) => {
        console.error("Failed to create ASP request:", {
          error: error.response?.data || error.message,
          searchID: this.state.searchID,
          email: data.email,
        });
        throw error;
      });
  };
  requestCallBack = (companyData) => {
    const data = prepareAspPayload(companyData);
    axios
      .post(`/api/aspreq/requestcallback/new`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // console.log("AXIOS RESPONSE: ", response);
        this.setState({ reqID: response.data.result._id });
        this.props.addCompanyInfo({
          id: "reqID",
          data: response.data.result._id,
          stateObject: "company_store",
        });
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      });
  };

  createCherryRequest = (companyData) => {
    let data = Object.assign({}, companyData);
    let ppArray = [];
    for (var i in data.potential_providers) {
      ppArray.push(data.potential_providers[i]);
    }
    data.potential_providers = ppArray;
    data.searchID =
      this.state.searchID ||
      this.props.company_store?.searchID ||
      data.searchID ||
      "";
    if (data.noofemployees === "") {
      data.noofemployees = 0;
    }
    if (data.incominginvoices === "") {
      data.incominginvoices = 0;
    }
    if (data.outgoinginvoices === "") {
      data.outgoinginvoices = 0;
    }

    axios
      .post(`/api/request`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const reqID = response.data.result._id;
        const cherryID = reqID;
        const searchID = response.data.searchID || this.state.searchID;

        console.log("Cherry Request created successfully:", {
          reqID: reqID,
          cherryID: cherryID,
          searchID: searchID,
          backendSearchID: response.data.searchID,
          existingSearchID: this.state.searchID,
        });

        this.setState({ cherryID: cherryID }, () => {
          this.props.addCompanyInfo({
            id: "cherryID",
            data: cherryID,
            stateObject: "company_store",
          });

          if (this.state.reqID === "" || !this.state.reqID) {
            this.setState({ reqID: reqID }, () => {
              this.props.addCompanyInfo({
                id: "reqID",
                data: reqID,
                stateObject: "company_store",
              });

              // Update searchID if backend created/returned one
              if (response.data.searchID && !this.state.searchID) {
                this.setState({ searchID: response.data.searchID }, () => {
                  this.props.addCompanyInfo({
                    id: "searchID",
                    data: response.data.searchID,
                    stateObject: "company_store",
                  });
                  this.handleSearchRequestSent(reqID);
                });
              } else {
                this.handleSearchRequestSent(reqID);
              }
            });
          } else {
            // Update searchID if backend created/returned one
            if (response.data.searchID && !this.state.searchID) {
              this.setState({ searchID: response.data.searchID }, () => {
                this.props.addCompanyInfo({
                  id: "searchID",
                  data: response.data.searchID,
                  stateObject: "company_store",
                });
                this.handleSearchRequestSent(reqID);
              });
            } else {
              this.handleSearchRequestSent(reqID);
            }
          }
        });
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error);
      });
  };
  updateRequest = (companyData, reqID = this.state.reqID) => {
    let data = Object.assign({}, companyData);
    if (data.potential_providers) {
      delete data.potential_providers;
    }
    if (data.noofemployees === "") {
      data.noofemployees = 0;
    }

    let dataToSend = { reqData: data, reqID: reqID };
    axios
      .patch(`/api/request/addprov`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // console.log("AXIOS RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      });
  };
  updateFakeCherryRequest = (companyData) => {
    let data = Object.assign({}, companyData);
    // if (data.potential_providers) {
    //   delete data.potential_providers;
    // }
    if (data.noofemployees === "") {
      data.noofemployees = 0;
    }

    let dataToSend = { reqData: data, reqID: this.state.reqID };

    axios
      .patch(`/api/aspreq/addprov/addfakecherry`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // console.log("AXIOS RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      });
  };

  handleSearchRequestSent = (reqID = null) => {
    const actualReqID = reqID || this.state.reqID;

    if (USE_WIREFRAME_ROUTE) {
      this.trackWireframeReqSentAnalytics(actualReqID);
    }
    this.updateSearchData(actualReqID);
  };

  submitSearchData = () => {
    const cs = this.props.company_store;
    if (!this.state.searchID && cs.searchID) {
      this.setState({ searchID: cs.searchID });
      return;
    }
    if (!this.state.searchID && !cs.searchID) {
      ensureSearchExists({
        flowType: "ASP",
        abVersion: "B",
        company_store: cs,
        addCompanyInfo: this.props.addCompanyInfo,
        step: this.state.activeStep + 1,
      }).then((searchID) => {
        if (searchID) this.setState({ searchID });
      });
      return;
    }
  };
  updateSearchData = (reqID = null) => {
    const effectiveSearchID =
      this.state.searchID || this.props.company_store?.searchID;
    if (
      !effectiveSearchID ||
      effectiveSearchID === "undefined" ||
      effectiveSearchID === "null"
    ) {
      return;
    }

    let data = { ...this.props.company_store };
    data.lang = this.props.company_store.chosenLanguage;
    if (!this.state.requestSent) {
      data.step = this.state.activeStep + 1;
    }
    // Only include reqID if we have a valid value (backend will set it anyway)
    // Don't send empty string which might overwrite backend value
    const actualReqID = reqID || this.state.reqID;
    if (
      actualReqID &&
      actualReqID !== "" &&
      actualReqID !== null &&
      actualReqID !== undefined
    ) {
      data.reqID = actualReqID;
    }
    data.abVersion = this.props.company_store.abVersion || "B";
    mergeUtmIntoPayload(
      data,
      this.state,
      resolveUtmParams({
        company_store: this.props.company_store,
        componentState: this.state,
      }),
    );
    data.distanceWeight = this.props.store.match_score_weights.distanceWeight;
    data.priceWeight = this.props.store.match_score_weights.priceWeight;
    data.reviewWeight = this.props.store.match_score_weights.reviewWeight;
    data.phoneWeight = this.props.store.match_score_weights.phoneWeight;
    data.availabilityWeight =
      this.props.store.match_score_weights.availabilityWeight;
    data.experienceWeight =
      this.props.store.match_score_weights.experienceWeight;
    data.liabilityInsWeight =
      this.props.store.match_score_weights.liabilityInsWeight;
    data.badgeWeight = this.props.store.match_score_weights.badgeWeight;

    // Do not overwrite an existing DB services array with an empty frontend default.
    // Only send `services` when there is at least one service selected.
    const normalizedServices = Array.isArray(data.services)
      ? data.services.filter(Boolean)
      : typeof data.services === "string" && data.services.trim()
        ? data.services
          .split(",")
          .map((service) => service.trim())
          .filter(Boolean)
        : [];
    if (normalizedServices.length > 0) {
      data.services = normalizedServices;
    } else {
      delete data.services;
    }

    if (
      this.props.potential_providers !== undefined &&
      this.props.potential_providers.constructor === Object &&
      this.props.potential_providers.some((e) => e.length !== 0)
    ) {
      let rPCounter = 0;
      this.props.potential_providers.forEach((e) => {
        rPCounter += e.length;
      });

      data.returnedProviders = rPCounter;
      let tempArray = [[], [], []];
      for (let i in this.props.potential_providers) {
        for (let j in i) {
          tempArray[i].push(this.props.potential_providers[i][j].companyname);
        }
      }
      data.providers = tempArray;
    }
    axios
      .patch(`/api/search/${effectiveSearchID}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // console.log("AXIOS RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      });
  };
  handleSearchUpdate = (prevStep) => {
    if (USE_WIREFRAME_ROUTE) {
      return;
    }
    if (this.state.activeStep !== prevStep) {
      if (this.state.activeStep !== COMPANY_TYPE_STEP) {
        this.updateSearchData();
      }
    }
    if (prevStep === "tableUpdate") {
      this.updateSearchData();
    }
  };
  updateViewedProviders = (provider) => {
    let data = {};
    let viewedProviders = this.state.viewedProviders;
    if (viewedProviders.length === 0) {
      viewedProviders.push(provider);
    }
    if (
      viewedProviders.length > 0 &&
      !viewedProviders.some((item) => item.name === provider.name)
    ) {
      viewedProviders.push(provider);
    }
    data.viewedProviders = viewedProviders;
    this.setState({
      viewedProviders: viewedProviders,
    });
    const effectiveSearchID =
      this.state.searchID || this.props.company_store?.searchID;
    if (
      !effectiveSearchID ||
      effectiveSearchID === "undefined" ||
      effectiveSearchID === "null"
    )
      return;
    axios
      .patch(`/api/search/${effectiveSearchID}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // console.log("AXIOS RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      });
  };

  renderStep = (stepIndex = this.state.activeStep) => {
    const stepConfig = STEPS[stepIndex];
    if (!stepConfig || !stepConfig.component) return i18n.t("general.notfound");
    const StepComponent = stepConfig.component;
    const commonProps = {
      handleNext: this.handleNext,
      handleBack: this.handleBack,
      openHelpForm: this.openHelpForm,
    };
    const extra = stepConfig.extraProps ? stepConfig.extraProps(this) : {};
    const valuePropProps =
      stepConfig.component === CommonValueProp
        ? {
            showTopBar:
              this.state.transitionFromStep === null &&
              this.state.activeStep === stepIndex,
          }
        : {};
    return <StepComponent {...commonProps} {...extra} {...valuePropProps} />;
  };

  renderStepContent = () => {
    const {
      activeStep,
      transitionFromStep,
      stepTransition,
      transitionViewportHeight,
    } = this.state;
    const isAnimating = transitionFromStep !== null;
    const panelSteps = isAnimating
      ? [transitionFromStep, activeStep]
      : [activeStep];

    const viewportStyle =
      isAnimating && transitionViewportHeight
        ? {
            height: transitionViewportHeight,
            minHeight: transitionViewportHeight,
          }
        : undefined;

    return (
      <div
        ref={this.setStepViewportRef}
        className={[
          classes.stepViewport,
          isAnimating ? classes.stepViewportAnimating : "",
        ]
          .filter(Boolean)
          .join(" ")}
        style={viewportStyle}
      >
        <div
          className={[
            classes.stepTrack,
            isAnimating ? classes.stepTrackAnimating : "",
            isAnimating
              ? stepTransition === "forward"
                ? classes.trackForward
                : classes.trackBack
              : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onAnimationEnd={isAnimating ? this.handleStepTrackAnimationEnd : undefined}
        >
          {panelSteps.map((stepIndex) => (
            <div key={stepIndex} className={classes.stepPanel}>
              {this.renderStep(stepIndex)}
            </div>
          ))}
        </div>
      </div>
    );
  };

  render() {
    const footerNav = getStepFooterNav(this, this.state.activeStep, STEPS);
    const aspProgress = getAspSearchFlowProgress(
      this,
      this.state.activeStep,
      STEPS,
    );
    const activeStepComponent = STEPS[this.state.activeStep]?.component;
    const isSettledOnValueProp =
      activeStepComponent === CommonValueProp &&
      this.state.transitionFromStep === null;
    const hideSearchFlowHeader = isSettledOnValueProp;
    const useRoutingShell = !isSettledOnValueProp;
    const hideContinueLater =
      !SHOW_CONTINUE_LATER_BUTTON ||
      hideSearchFlowHeader ||
      activeStepComponent === EvContactPage ||
      activeStepComponent === CompanyContactPage ||
      activeStepComponent === EvSuccessScreen ||
      activeStepComponent === CompanySuccessScreen ||
      activeStepComponent === GeneralError;
    const showAspManualFooterProviderCount = isAspManualPostQuickResultFooterCountStep(
      this,
      this.state.activeStep,
      STEPS,
    );

    return (
      <>
        <VacationNotice />
        <div
          className={[
            classes.container,
            hideSearchFlowHeader ? classes.valuePropContainer : "",
            useRoutingShell ? classes.routingContainer : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <Dialog
            open={this.props.company_store.idk || this.state.helpForm}
            onClose={() => {
              this.props.company_store.idk === true
                ? this.props.addCompanyInfo({
                  id: "idk",
                  data: false,
                  stateObject: "company_store",
                })
                : this.setState({ helpForm: false });
            }}
            handleClose={() => {
              this.props.company_store.idk === true
                ? this.props.addCompanyInfo({
                  id: "idk",
                  data: false,
                  stateObject: "company_store",
                })
                : this.setState({ helpForm: false });
            }}
          >
            <KnetPlusForm
              kNetPlusSent={this.state.kNetPlusSent}
              handleKnetPlusContact={this.handleKnetPlusContact}
              closeHelpForm={this.closeHelpForm}
              helpForm={this.state.helpForm}
            />
          </Dialog>
          {hideSearchFlowHeader ? null : (
            <SearchFlowHeader hideContinueLater={hideContinueLater} />
          )}
          <div className={classes.stepContent}>{this.renderStepContent()}</div>
          <SearchFlowFooterShell
            progress={hideSearchFlowHeader ? null : aspProgress}
            footerNav={footerNav}
            isTransitioning={this.state.transitionFromStep !== null}
            footerCenterContent={
              showAspManualFooterProviderCount ? (
                <SearchFlowFooterProviderCount enabled />
              ) : null
            }
          />
          {ENABLE_SEARCH_FLOW_MONITORS &&
            !(
              STEPS[this.state.activeStep]?.component === CompanySuccessScreen ||
              STEPS[this.state.activeStep]?.component === EvSuccessScreen
            ) && <Monitors />}
          <div style={{ display: "none" }}>
            <p>Hidden fields</p>
            <input type="hidden" />
            <br />
            <input type="text" id="utm_source" name="utm_source" />
            <br />
            <input type="text" id="utm_medium" name="utm_medium" />
            <br />
            <input type="text" id="utm_campaign" name="utm_campaign" />
            <br />
            <input type="text" id="utm_content" name="utm_content" />
            <br />
            <input type="text" id="utm_term" name="utm_term" />
            <br />
            <input type="text" id="gclid" name="gclid" />
            <br />
            <input type="text" id="dclid" name="dclid" />
            <br />
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(SearchFlowVersionB),
);
